import React from 'react';
import { Box, FormControl, Select, MenuItem, TextField } from '@mui/material';

const GroupSizeField = ({ dataPoint, index, handleFieldChange }) => {
  const groupSizeOptions = [
    'Individual',
    'Group of 1',
    'Group of 2',
    'Group of 3',
    'Group of 4',
    'Group of 5',
    'Other',
  ];

  const isOtherSelected = dataPoint.groupSize === 'Other';
  const customGroupSize = dataPoint.customGroupSize || '';

  return (
    <Box sx={{ gap: 1, display: 'flex', flexDirection: 'column' }}>
      <FormControl sx={{ width: '60%' }}>
        <Select
          value={dataPoint.groupSize}
          onChange={(e) =>
            handleFieldChange(index, 'groupSize', e.target.value)
          }
          displayEmpty
          size='small'
          sx={{
            backgroundColor: 'var(--clr-mindly-white)',
            '& .MuiOutlinedInput-root': {
              height: '32px',
              '& .MuiOutlinedInput-input': {
                padding: '6px 12px',
                fontSize: '14px',
              },
            },
          }}
        >
          <MenuItem value='' disabled>
            Select group size
          </MenuItem>
          {groupSizeOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {isOtherSelected && (
        <TextField
          type='number'
          label={`Group of ${customGroupSize || ''}`}
          value={customGroupSize}
          onChange={(e) => {
            const value = e.target.value;
            handleFieldChange(index, 'customGroupSize', value);
          }}
          size='small'
          inputProps={{ min: 1 }}
          sx={{
            width: '60%',
            backgroundColor: 'var(--clr-mindly-white)',
            '& .MuiOutlinedInput-root': {
              height: '32px',
              '& .MuiOutlinedInput-input': {
                padding: '6px 12px',
                fontSize: '14px',
              },
            },
          }}
        />
      )}
    </Box>
  );
};

export default GroupSizeField;
